import SupportCard from "../Utils/Supportcard"
import Diamond from "../Assets/Diamond.png"
import Growth from "../Assets/Growth.png"
import Market from "../Assets/Market.png"
import Barrier from "../Assets/Barrier.png"
import Diverse from "../Assets/Diverse.png"
import Business from "../Assets/Business.png"
import { Swiper, SwiperSlide } from 'swiper/react';

import { Navigation, Pagination, Scrollbar, A11y, FreeMode, Thumbs, Autoplay } from 'swiper'


// Import Swiper styles
import 'swiper/css';
import "swiper/css/navigation";
import "swiper/css/free-mode";
import "swiper/css/thumbs";


const Support=()=>
{
    const lgdata=[{"title":"Large, Fragmented and Growing Tam","url":Growth},
    {"title":"Responsive Market growth by 65%","url":Market},
    {"title":"Highly Strategic Asset class","url":Diamond},
    {"title":"Growing Business Moat/Barrier for competition","url":Barrier},
    {"title":"Investment diversification","url":Diverse},
    {"title":"Right Time for Business Inflection/Growth","url":Business},
]
    const data=[
     [   
     {"title":"Large, Fragmented and Growing Tam","url":Growth},
    {"title":"Responsive Market growth by 65%","url":Market},
    {"title":"Highly Strategic Asset class","url":Diamond}
],[
    {"title":"Growing Business Moat/Barrier for competition","url":Barrier},
    {"title":"Investment diversification","url":Diverse},
    {"title":"Right Time for Business Inflection/Growth","url":Business},
]
]

    return(
        <div className="sm:px-[16px] lg:px-[160px] sm:pt-[30px] lg:py-[45px]">
            <p  style={{fontFamily:"Playfair Display"}} className="text-[#C69130] sm:text-[22px] lg:text-[32px] font-[600] sm:mb-[0px] lg:my-[70px] sm:leading-[38px] lg:leading-[56px] tracking-[0.5px]">Why Invest In BRIK itt Holiday Rental</p>
            
            <div style={{fontFamily:"Inter"}} className="sm:hidden lg:block lg:grid grid-cols-3 gap-y-[70px] gap-x-[30px]">
                {lgdata?.map((e,i)=>
                {
                    return <SupportCard key={i} url={e.url} title={e.title}/>
                })}
            </div>
            <div className='sm:block sm:mb-[30px] z-10 lg:hidden'>
                
                <Swiper 
                
                modules={[Pagination, Navigation, Autoplay]}
                className="myswiper"
                direction='horizontal'
                pagination= {{
                    el: '.swiper-custom-pagination',
                  }}
                loop="true"
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}>
                    {
                        data?.map((item,i)=>
                        {
                            return(
                                <SwiperSlide className='mt-[35px] ' key={i}>
                                     <div className="flex flex-col gap-[50px]">
                                     {item?.map((e,ind)=>
                                        {
                                             
                                             return <SupportCard key={i} url={e.url} title={e.title}/>}
                                        )}
                                     </div>
                                </SwiperSlide>
                            )
                        })
                    }
                    <div className="swiper-custom-pagination"/>
                </Swiper>
                
            </div>
        </div>
    )
}
export default Support